import { render, staticRenderFns } from "./ImgPreview.vue?vue&type=template&id=116440c8&scoped=true&"
import script from "./ImgPreview.vue?vue&type=script&lang=js&"
export * from "./ImgPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=116440c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116440c8",
  null
  
)

export default component.exports